import React from 'react';
import {ProvideCredencial} from "./State/ProvideCredencial";
import VistaCredencial from "./VistaCredencial";


const Credencial = () => {

    return (
        <ProvideCredencial>
            <VistaCredencial/>
        </ProvideCredencial>
    );
};

export default Credencial;